import _extends from "@babel/runtime/helpers/esm/extends";
import axios from 'axios';
import { findKey, pickBy } from 'lodash';
import sanitizeToken from './sanitizeToken';

/**
 * @deprecated
 */
export let EModelEnv;

// TODO move to .env
(function (EModelEnv) {
  EModelEnv["Localhost"] = "localhost";
  EModelEnv["CHC"] = "chc";
  EModelEnv["Demo"] = "demo";
  EModelEnv["DesignTest"] = "designtest";
  EModelEnv["Staging"] = "staging";
  EModelEnv["Staging2"] = "staging2";
  EModelEnv["Production"] = "production";
  EModelEnv["OCI"] = "oci";
  EModelEnv["Green"] = "green";
  EModelEnv["ICT"] = "ict";
  EModelEnv["PLT"] = "plt";
  EModelEnv["STL"] = "stl";
  EModelEnv["RASA"] = "rasa";
  EModelEnv["RPC"] = "rpc";
  EModelEnv["Teal"] = "teal";
  EModelEnv["Red"] = "red";
  EModelEnv["Blue"] = "blue";
  EModelEnv["Yellow"] = "yellow";
  EModelEnv["Gold"] = "gold";
  EModelEnv["Silver"] = "silver";
  EModelEnv["Emerald"] = "emerald";
})(EModelEnv || (EModelEnv = {}));
const baseUrlsPerEnv = {
  [EModelEnv.Localhost]: 'http://localhost:8002/api',
  [EModelEnv.CHC]: 'https://api.nextgen.lumahealthdemo.com/api',
  [EModelEnv.Demo]: 'https://api.lumahealthdemo.com/api',
  [EModelEnv.DesignTest]: 'https://api-preprod.lumahealth.io/api',
  [EModelEnv.Green]: 'https://api.green.isbuildingluma.com/api',
  [EModelEnv.ICT]: 'https://api.ict.isbuildingluma.com/api',
  [EModelEnv.STL]: 'https://api.stl.isbuildingluma.com/api',
  [EModelEnv.Teal]: 'https://api.teal.isbuildingluma.com/api',
  [EModelEnv.Blue]: 'https://api.blue.isbuildingluma.com/api',
  [EModelEnv.Yellow]: 'https://api.yellow.isbuildingluma.com/api',
  [EModelEnv.Red]: 'https://api.red.isbuildingluma.com/api',
  [EModelEnv.Gold]: 'https://api.gold.isbuildingluma.com/api',
  [EModelEnv.Emerald]: 'https://api.emerald.isbuildingluma.com/api',
  [EModelEnv.Silver]: 'https://api.silver.isbuildingluma.com/api',
  [EModelEnv.PLT]: 'https://api.plt.isbuildingluma.com/api',
  [EModelEnv.RASA]: 'https://api.rasa.isbuildingluma.com/api',
  [EModelEnv.RPC]: 'https://api.rpc.isbuildingluma.com/api',
  [EModelEnv.Staging]: 'https://api.lumahealthstaging.com/api',
  [EModelEnv.Staging2]: 'https://api2.lumahealthstaging.com/api',
  [EModelEnv.Production]: 'https://api.lumahealth.io/api',
  [EModelEnv.OCI]: 'https://api.oci.lumahealthdemo.com/api'
};

/**
 * @deprecated use `lumahealthhq/ui-utils#usePodName`
 */
export function getAxiosClientEnv(axiosClient) {
  const baseUrl = axiosClient.defaults.baseURL;
  const env = findKey(baseUrlsPerEnv, value => value === baseUrl);
  return env;
}

/**
 * @deprecated
 *
 * Create a new instance of axios to be used as default client
 * https://github.com/axios/axios#creating-an-instance
 */
export default function createAxiosClientDeprecated(keyAuthToken, env = EModelEnv.Staging) {
  const axiosClient = axios.create({
    baseURL: baseUrlsPerEnv[env]
  });
  axiosClient.interceptors.request.use(config => {
    const token = localStorage.getItem(keyAuthToken);
    return _extends({}, config, {
      headers: pickBy(_extends({
        'x-access-token': sanitizeToken(token)
      }, config.headers))
    });
  });
  axiosClient.interceptors.response.use(response => {
    const token = response.headers['x-access-token'];
    if (token) {
      localStorage.setItem(keyAuthToken, token);
    }
    return response;
  });
  return axiosClient;
}